import { configureStore } from '@reduxjs/toolkit';
import authReducer from './authSlice';
import personasReducer from './personasSlice';
import streamlinerReducer from './streamlinerSlice';
import qaAutomationReducer from './qaAutomationSlice';
import atlasReducer from './atlasSlice';

export const store = configureStore({
	reducer: {
		auth: authReducer,
		personas: personasReducer,
		streamliner: streamlinerReducer,
		qaAutomation: qaAutomationReducer,
		atlas: atlasReducer
	},
	middleware: getDefaultMiddleware => getDefaultMiddleware({
		serializableCheck: false
	})
});

export default store;
